/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ListCategoriesCategoriesGet$Params {}

export function listCategoriesCategoriesGet(
  http: HttpClient,
  rootUrl: string,
  params?: ListCategoriesCategoriesGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, listCategoriesCategoriesGet.PATH, 'get');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<string>>;
    }),
  );
}

listCategoriesCategoriesGet.PATH = '/categories';
